import { render, staticRenderFns } from "./task-create.vue?vue&type=template&id=d3e6da4a&"
import script from "./task-create.vue?vue&type=script&lang=js&"
export * from "./task-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports